var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendEmailEnabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333223 3.40947C0 4.64946 0 6.36008 0 9C0 12.7497 0 14.6246 0.954915 15.9389C1.26331 16.3634 1.6366 16.7367 2.06107 17.0451C3.3754 18 5.25027 18 9 18H11C14.7497 18 16.6246 18 17.9389 17.0451C18.3634 16.7367 18.7367 16.3634 19.0451 15.9389C20 14.6246 20 12.7497 20 9C20 6.35129 20 4.63806 19.6634 3.39709L17.5607 5.49986C15.9284 7.13214 14.6492 8.41132 13.517 9.2752C12.3581 10.1594 11.2653 10.6789 9.99986 10.6789C8.73441 10.6789 7.64167 10.1594 6.48274 9.2752C5.35048 8.41132 4.07131 7.13213 2.43904 5.49984L0.483855 3.54466L0.333223 3.40947Z",
    fill: "#2D264B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2L1.10885 2.09007L1.51587 2.45535L3.45913 4.39861C5.14079 6.08027 6.34981 7.28703 7.39261 8.08267C8.41812 8.8651 9.19425 9.17894 9.99986 9.17894C10.8055 9.17894 11.5816 8.8651 12.6071 8.08267C13.6499 7.28703 14.8589 6.08027 16.5406 4.39861L18.8485 2.0907L18.9741 1.96579C18.6657 1.54132 18.3634 1.26331 17.9389 0.954915C16.6246 0 14.7497 0 11 0H9C5.25027 0 3.3754 0 2.06107 0.954915C1.6366 1.26331 1.3084 1.57553 1 2Z",
    fill: "#2D264B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmailEnabled);
export default __webpack_public_path__ + "static/media/send-email-enabled.94cc1d4d5fd7d3e462778982e52ed7c7.svg";
export { ForwardRef as ReactComponent };